import _classCallCheck from "/home/catdrout/Desktop/gatsby-starter-mate/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/home/catdrout/Desktop/gatsby-starter-mate/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/catdrout/Desktop/gatsby-starter-mate/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/catdrout/Desktop/gatsby-starter-mate/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/home/catdrout/Desktop/gatsby-starter-mate/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 */
import { stringifyPosition } from 'unist-util-stringify-position';
export var VFileMessage = /*#__PURE__*/function (_Error) {
  _inherits(VFileMessage, _Error);

  var _super = _createSuper(VFileMessage);

  /**
   * Constructor of a message for `reason` at `place` from `origin`.
   * When an error is passed in as `reason`, copies the `stack`.
   *
   * @param {string|Error} reason Reason for message (`string` or `Error`). Uses the stack and message of the error if given.
   * @param {Node|Position|Point} [place] Place at which the message occurred in a file (`Node`, `Position`, or `Point`, optional).
   * @param {string} [origin] Place in code the message originates from (`string`, optional).
   */
  function VFileMessage(reason, place, origin) {
    var _this;

    _classCallCheck(this, VFileMessage);

    /** @type {[string?, string?]} */
    var parts = [null, null];
    /** @type {Position} */

    var position = {
      start: {
        line: null,
        column: null
      },
      end: {
        line: null,
        column: null
      }
    };
    /** @type {number} */

    var index;
    _this = _super.call(this);

    if (typeof place === 'string') {
      origin = place;
      place = null;
    }

    if (typeof origin === 'string') {
      index = origin.indexOf(':');

      if (index === -1) {
        parts[1] = origin;
      } else {
        parts[0] = origin.slice(0, index);
        parts[1] = origin.slice(index + 1);
      }
    }

    if (place) {
      // Node.
      if ('type' in place || 'position' in place) {
        if (place.position) {
          position = place.position;
        }
      } // Position.
      else if ('start' in place || 'end' in place) {
        // @ts-ignore Looks like a position.
        position = place;
      } // Point.
      else if ('line' in place || 'column' in place) {
        // @ts-ignore Looks like a point.
        position.start = place;
      }
    } // Fields from `Error`


    _this.name = stringifyPosition(place) || '1:1';
    _this.message = typeof reason === 'object' ? reason.message : reason;
    _this.stack = typeof reason === 'object' ? reason.stack : '';
    /**
     * Reason for message.
     * @type {string}
     */

    _this.reason = _this.message;
    /**
     * Starting line of error.
     * @type {number?}
     */

    _this.line = position.start.line;
    /**
     * Starting column of error.
     * @type {number?}
     */

    _this.column = position.start.column;
    /**
     * Namespace of warning.
     * @type {string?}
     */

    _this.source = parts[0];
    /**
     * Category of message.
     * @type {string?}
     */

    _this.ruleId = parts[1];
    /**
     * Full range information, when available.
     * Has start and end properties, both set to an object with line and column, set to number?.
     * @type {Position?}
     */

    _this.position = position; // The following fields are “well known”.
    // Not standard.
    // Feel free to add other non-standard fields to your messages.

    /* eslint-disable no-unused-expressions */

    /**
     * You may add a file property with a path of a file (used throughout the VFile ecosystem).
     * @type {string?}
     */

    _this.file;
    /**
     * If true, marks associated file as no longer processable.
     * @type {boolean?}
     */

    _this.fatal;
    /**
     * You may add a url property with a link to documentation for the message.
     * @type {string?}
     */

    _this.url;
    /**
     * You may add a note property with a long form description of the message (supported by vfile-reporter).
     * @type {string?}
     */

    _this.note;
    /* eslint-enable no-unused-expressions */

    return _this;
  }

  return VFileMessage;
}( /*#__PURE__*/_wrapNativeSuper(Error));
VFileMessage.prototype.file = '';
VFileMessage.prototype.name = '';
VFileMessage.prototype.reason = '';
VFileMessage.prototype.message = '';
VFileMessage.prototype.stack = '';
VFileMessage.prototype.fatal = null;
VFileMessage.prototype.column = null;
VFileMessage.prototype.line = null;
VFileMessage.prototype.source = null;
VFileMessage.prototype.ruleId = null;
VFileMessage.prototype.position = null;